import { AbstractFilterBuilder } from "./AbstractFilterBuilder";

export class RegionFilterBuilder extends AbstractFilterBuilder {
    public build(value: string): string {
        return `["${this.table}","${this.field}","in",["${value}"]]`
    }
}